import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { H4 } from "@churchofjesuschrist/eden-headings";
import Stack from "@churchofjesuschrist/eden-stack";
import { spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { rowContainer, labelContainer } from "./shared";
const Container = styled.section.withConfig({
  componentId: "sc-j8ndjn-0"
})(["& + &{margin-block-start:", ";}"], spacing8);
const RowContainer = styled.div.withConfig({
  componentId: "sc-j8ndjn-1"
})(["", ";"], rowContainer);
const LabelContainer = styled(H4).withConfig({
  componentId: "sc-j8ndjn-2"
})(["", ";"], labelContainer);

const NavigationBlockHeading = _ref => {
  let {
    children,
    label,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, rest, /*#__PURE__*/React.createElement(RowContainer, null, /*#__PURE__*/React.createElement(LabelContainer, {
    renderAs: "div"
  }, label)), /*#__PURE__*/React.createElement(Stack, {
    gapSize: "0"
  }, children));
};

NavigationBlockHeading.propTypes = {
  /** Should consist of one or more `NavigationSub*` components to render inside */
  children: PropTypes.node.isRequired,

  /** The contents of the heading */
  label: PropTypes.node.isRequired
};
export default NavigationBlockHeading;